// extracted by mini-css-extract-plugin
module.exports = {"Login":"Styles_Login__rn9v4","Form":"Styles_Form__3i4tS","Buttons":"Styles_Buttons__-sFtm","red":"Styles_red__2P6dC","FButton":"Styles_FButton__3xCmM"};